import TideDashboardV2 from './TideDashboardV2';

export default TideDashboardV2;
